import { render, staticRenderFns } from "./IndexBack.vue?vue&type=template&id=0ce992af&scoped=true"
import script from "./IndexBack.vue?vue&type=script&lang=js"
export * from "./IndexBack.vue?vue&type=script&lang=js"
import style0 from "./IndexBack.vue?vue&type=style&index=0&id=0ce992af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce992af",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce992af')) {
      api.createRecord('0ce992af', component.options)
    } else {
      api.reload('0ce992af', component.options)
    }
    module.hot.accept("./IndexBack.vue?vue&type=template&id=0ce992af&scoped=true", function () {
      api.rerender('0ce992af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/IndexBack.vue"
export default component.exports